import React from "react";
import { Tooltip as PrimeTooltip } from 'primereact/tooltip';


function Tooltip(props) {

    let target = props.target ? props.target : ""
    let position = props.position ? props.position : "top"
    let content = props.content ? props.content : ""
    let showDelay = props.showDelay ? props.showDelay : 500
    let hideDelay = props.hideDelay ? props.hideDelay : 150
    let autoHide = true
    let disabled = false
    let showOnDisabled = props.showOnDisabled


    return (
        <PrimeTooltip 
            target={target} 
            position={position} 
            content={content} 
            autoHide={autoHide} 
            showDelay={showDelay} 
            hideDelay={hideDelay} 
            disabled={disabled}
            children={props.children}
            showOnDisabled={showOnDisabled}
        />
    )
}

export default Tooltip